import { render, staticRenderFns } from "./ItineraryModulesReorder.vue?vue&type=template&id=63f2e078&"
import script from "./ItineraryModulesReorder.vue?vue&type=script&lang=js&"
export * from "./ItineraryModulesReorder.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryModulesReorder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports